<template>
    
    <div v-if="this.$store.getters.Loaded" class="home">
        <NavUser/>
        <Reports/>
    </div>  
    <LoadStatus/>
</template>



<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import LoadStatus from '@/components/LoadSatus.vue'
import Reports from '@/components/ReportsBlock.vue'
import NavUser from '@/components/NavBarUser.vue';
export default {
  name: 'PersonalView',
  components: {
    LoadStatus,
    NavUser,
    Reports

  }  
}



</script>